import { render, staticRenderFns } from "./local.vue?vue&type=template&id=3d8d76e6&"
import script from "./local.vue?vue&type=script&lang=js&"
export * from "./local.vue?vue&type=script&lang=js&"
import style0 from "./local.vue?vue&type=style&index=0&id=3d8d76e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports